import { Injectable } from '@angular/core';

import { AuthConfigService } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class CustomAuthConfigService extends AuthConfigService {
  protected prefixEndpoint(endpoint: string): string {
    const url = endpoint;
    if (url.startsWith('http')) {
      return url;
    }
    return super.prefixEndpoint(endpoint);
  }
}
